import { Maybe } from "./types";

const possibleBools = new Set(["true", "1", "yes"]);
export function toBool(input: Maybe<string>) {
  return (
    typeof input === "string" && possibleBools.has(input.trim().toLowerCase())
  );
}
